import React, { useRef, useEffect, useMemo } from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

const SplitText = ({
  wrapper: WrapperTag,
  copy,
  splitBy,
  wpl,
  animate,
  stagger,
  delay,
  classNames,
  role,
}) => {
  const headingRef = useRef();
  const splitByWord = copy.split(" ");
  const wplvar = wpl;
  const splitByLines = useMemo(() => {
    function sliceIntoChunks(arr, chunkSize) {
      const res = [];
      for (let i = 0; i < arr.length; i += chunkSize) {
        const chunk = arr.slice(i, i + chunkSize);
        res.push(chunk);
      }
      return res;
    }
    return sliceIntoChunks(splitByWord, wplvar);
  }, [copy, wplvar]);

  // Animate Split Text
  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    if (animate === "words") {
      let ctx = gsap.context(() => {
        gsap.set(".split-word", {
          x: -100,
          clipPath: "polygon(0% 100%, 0% 100%, 0% 0%, 0% 0%)",
        });

        gsap.to(".split-word", {
          autoAlpha: 1,
          x: 0,
          clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
          duration: 0.8,
          stagger: stagger,
          delay: delay,
          ease: "power4.out",
          scrollTrigger: {
            trigger: headingRef.current,
            start: "top 80%",
            markers: false,
          },
        });
      }, headingRef.current);

      return () => ctx.revert();
    }
  }, [animate, stagger, delay]);

  return (
    <WrapperTag className={classNames} ref={headingRef}>
      <span className='split-wrapper' area-label={copy} role={role}>
        {splitBy === "words" &&
          splitByWord.map((word, index) => {
            if (index + 1 === splitByWord.length) {
              var newWord = word;
            } else {
              newWord = word + " ";
            }
            return (
              <span aria-hidden='true' className='split-word' key={index}>
                {newWord}
              </span>
            );
          })}
        {splitBy === "lines" &&
          splitByLines.map((line, index) => {
            return (
              <span aria-hidden='true' className='split-line' key={index}>
                {line.map((word, index) => {
                  let newWord;
                  if (index + 1 === line.length) {
                    newWord = word;
                  } else {
                    newWord = word + " ";
                  }
                  return (
                    <span aria-hidden='true' className='split-word' key={index}>
                      {newWord}
                    </span>
                  );
                })}
              </span>
            );
          })}
      </span>
    </WrapperTag>
  );
};

export default SplitText;
